import { useMutation } from "@apollo/client/react";
import { SET_MANUAL_REVIEW_REQUIRED } from "../../mutations/invoices/setManualReviewRequired";
import GET_CLIENT_ASSESSMENT_INVOICES from "../../queries/invoices/getClientAssessmentInvoices";
import GET_INVOICE_ASSESSMENT_DETAILS from "../../queries/invoices/getInvoiceAssessmentDetails";

export const useSetManualReviewRequired = ({
  onCompleted,
  onError,
  noRefetch = false,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
  noRefetch?: boolean;
}) => {
  const [setManualReviewRequired, { data, loading, error }] = useMutation(
    SET_MANUAL_REVIEW_REQUIRED,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: noRefetch
        ? []
        : [GET_CLIENT_ASSESSMENT_INVOICES, GET_INVOICE_ASSESSMENT_DETAILS],
      awaitRefetchQueries: true,
    },
  );

  return { setManualReviewRequired, data, loading, error };
};
